export default __webpack_public_path__ + "static/media/1-shine.32007622.png";